'use strict';

var localConfig;

try {
  localConfig = require('../../local_config');
} catch (e) {
  localConfig = {};
}


module.exports = angular.merge({
  apiBaseUrl: '/api_v1',
  apiBaseUrlV2: '/api_v2',
  imgUrl: '//showaroundoriginal.imgix.net/',
  imgQuality: 60,
  socketUrl: 'sa.local:31337',
  socials: {
    facebook: {
      appId: 1573475539547795,
      pageId: 1504165226499871,
      scope: 'public_profile,email'
    },
    vk: {
      appId: 4579843,
      scope: 4 + 4194304
    }
  },
  supportEmail: 'support@showaround.com',
  supportPhoneNumber: '+353 1 254 4809',
  verificationPhotoDownloadUrl: 'https://s3-eu-west-1.amazonaws.com/images.original.showaround/',
  iosAppUrl: 'https://itunes.apple.com/app/showaround-find-local-to-show/id1001885430',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=com.showaround',
  blogUrl: 'http://blog.showaround.com/',
  pressPageUrl: '/press',
  googleApiKey: 'AIzaSyBsKn0lVR7nBu4nKZQTLXXeSo91GE1vwlM'
}, localConfig);



// WEBPACK FOOTER //
// ./app/src/config.js